import { type RefObject, useCallback, useEffect, useRef } from 'react'

/**
 * Add ClickOutside event to element
 *
 * @param {() => void} onClickOutside - Callback to perform when click outside
 * @returns {RefObject<HTMLDivElement | null>} - Add this to ref on element
 */
export function useClickOutside (onClickOutside: () => void): RefObject<HTMLDivElement | null> {
  const wrapperRef = useRef<HTMLDivElement | null>(null)

  const handleClickOutside = useCallback((evt: MouseEvent) => {
    if ((wrapperRef.current != null) && !wrapperRef.current.contains(evt.target as Node)) {
      onClickOutside()
    }
  }, [wrapperRef, onClickOutside])

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true)
    return () => { document.removeEventListener('click', handleClickOutside, true) }
  }, [handleClickOutside])

  return wrapperRef
}
